<template>
  <v-application v-if="access.setting_stores">
    <v-layout row class="ma-2">
      <v-flex md8>
        <v-crud-card
          name="store"
          v-bind:headers="headers"
          v-bind:data="services"
          v-bind:remove="remove_service"
          v-bind:row="edit_service"
          v-bind:save="save_service"
          v-bind:add_button_name="'add_store'"
          invanStore
          no-delete
          :dialogWidth=600
          v-bind:deleteStore="remove_service"
          v-bind:saveDisabled="
            !valid ||
            !(
              (typeof service.description == typeof 'invan' &&
                service.description.length <= 255) ||
              typeof service.description != typeof 'invan'
            )
          "
        >
          <v-card-text>
            <v-form v-model="valid">
              <v-text-field
                :label="$t('name')"
                v-model="service.name"
                ref="name"
                :rules="[fieldRules.required]"
              />
              <v-radio-group v-model="service.type" row :label="$t('type')">
                <v-radio :label="$t('shop')" value="shop" />
                <v-radio :label="$t('restaurant')" value="restaurant" />
                <v-radio :label="$t('market')" value="market" />
              </v-radio-group>
              <v-select
                v-model="workDays"
                :items="weeks"
                attach
                :label="$t('working_days')"
                multiple
              ></v-select>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-menu
                    ref="fromMenu"
                    v-model="fromMenu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="fromTime"
                    transition="scale-transition"
                    offset-y
                    max-width="200px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fromTime"
                        :label="$t('from')"
                        prepend-icon="mdi-clock-alert-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="fromMenu2"
                      v-model="fromTime"
                      format="24hr"
                      full-width
                      @click:minute="$refs.fromMenu.save(fromTime)"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-menu
                    ref="toMenu"
                    v-model="toMenu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="toTime"
                    transition="scale-transition"
                    offset-y
                    max-width="200px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="toTime"
                        :label="$t('to')"
                        prepend-icon="mdi-clock-alert-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="toMenu2"
                      v-model="toTime"
                      format="24hr"
                      full-width
                      @click:minute="$refs.toMenu.save(toTime)"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-text-field
                :label="$t('phone_number')"
                prefix="+"
                v-mask="mask"
                v-model="service.phone_number"
                prepend-icon="mdi-phone"
              />

              <v-list-item v-bind:key="1">
                <v-list-item-content>
                  <v-list-item-title>{{ $t("status") }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch v-model="service.is_active" />
                </v-list-item-action>
              </v-list-item>

              <GmapMap
                ref="mapRef"
                style="width: 550px; height: 400px;"
                map-style-id="roadmap"
                :zoom="11"
                :center="{lat: mapCenter.position.lat, lng: mapCenter.position.lng}"
                @click="mark"
                @drag="mark"
              >
                <GmapMarker
                  :key="index"
                  :clickable="true"
                  :draggable="true"
                  :position="marker.position"
                />
              </GmapMap>
              <v-text-field
                :label="$t('address')"
                v-model="service.address"
                prepend-icon="mdi-map-marker"
              />
              <v-text-field
                :label="$t('description')"
                v-model="service.description"
                prepend-icon="mdi-note-text"
                counter="255"
              />
            </v-form>
          </v-card-text>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
import {gmapApi} from 'vue2-google-maps'
export default {
  name: "SettingsStores",
  mixins: [Services],
  data: () => ({
    mask: "### (##) ###-##-##",
    headers: [
      { text: "Name", value: "name", align: "left" },
      { text: "Address", value: "address" },
      { text: "Number of POS", value: "count", align: "right" },
    ],
    data: [],
    marker: {position: {lat: 41.295002478807255, lng: 69.26550840838453}},
    mapCenter: {position: {lat: 41.295002478807255, lng: 69.26550840838453}},
    weeks: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ],
    workDays: [],
    valid: false,
    fromTime: '',
    toTime: '',
    toMenu: false,
    toMenu2: false,
    fromMenu: false,
    fromMenu2: false,
  }),
  mounted() {
    this.headers = [
      { text: this.$t("name"), value: "name", align: "left", available: true },
      { text: this.$t("address"), value: "address", available: true },
      {
        text: this.$t("number_of_pos"),
        value: "count",
        align: "right",
        available: true,
      },
      { text: this.$t("status"), value: "is_active", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  methods: {
		mark(e){
      this.marker.position.lat = e?.latLng?.lat()
      this.marker.position.lng = e?.latLng?.lng()
		}
	},
	computed: {
		google: gmapApi
	},
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
